<template>
    <div class="navbar" style="padding:0px">
            <nav class="nav-extended indigo darken-3">
                <div class="nav-content">
                    <div class="row">
                        <div class="col-auto valign-wrapper left ">
                            <router-link to="/" style="text-decoration:none">
                                <i class="home material-icons" >home</i>
                            </router-link>
                            
                        </div>
                        <div class="col" style="padding:0px">
                                <a v-if="route" class="nav-title" style="padding-bottom:0px;text-decoration:none" v-bind:href="route"> {{Title}}</a>
                                <span v-else class="nav-title" style="padding-bottom:0px">{{Title}}</span>
                        </div>

                    </div>   
              </div>
          </nav>
        </div>
</template>

<script>
export default {
    name: 'Navbar',
  props: {
    Title: String,
    route: String,
  }
}
</script>


<style scoped>
.home{
    padding: 12px 10px;
    font-size:250%;
}

</style>